import { render, staticRenderFns } from "./VerificationWizard.vue?vue&type=template&id=c9ec8d9e&scoped=true"
import script from "./VerificationWizard.vue?vue&type=script&lang=js"
export * from "./VerificationWizard.vue?vue&type=script&lang=js"
import style0 from "./VerificationWizard.vue?vue&type=style&index=0&id=c9ec8d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ec8d9e",
  null
  
)

export default component.exports